export const setupSearchAutocomplete = () => {
	class SearchBox {
		search: HTMLInputElement;
		parent: HTMLElement | null;
		autocomplete: HTMLElement | null;
		autocompleteIndex: number;
		autocompleteActive: boolean;
		inputRoles: string[];
		controlServerData: any;
		searchTextBox: HTMLInputElement | null;
		searchButton: HTMLElement | null;
		autocompleteResults: string[];
		searchValue: string;

		// @Param {element} - Hidden Input element data-sf-role="searchTextBoxId"
		constructor(element: Element) {
			this.search = element as HTMLInputElement;
			this.parent = element.parentElement;
			this.settings();
			this.events();
		}
		settings() {
			this.autocomplete = this.parent?.querySelector('[data-sf-role="autocomplete"]') || null;
			this.autocompleteIndex = -1;
			this.autocompleteActive = false;
			this.inputRoles = ['resultsUrl', 'indexCatalogue', 'disableSuggestions', 'minSuggestionLength', 'suggestionFields', 'language', 'siteId', 'suggestionsRoute', 'searchButtonId', 'scoringSettings'];
			this.controlServerData = {
				searchTextBoxSelector: this.search.value,
			};
			this.inputRoles.forEach((role) => {
				const input = this.parent?.querySelector(`[data-sf-role="${role}"]`) as HTMLInputElement | null;
				if (input) {
					this.controlServerData[role] = input.value;
				}
			});
			this.featherSearchBoxWidget();
		}
		events() {
			// add click event to select autocomplete values
			if (this.autocomplete) {
				this.autocomplete.addEventListener('click', this.selectAutocompleteResult.bind(this));
			}
		}
		featherSearchBoxWidget() {
			this.searchTextBox = document.getElementById(`${this.controlServerData.searchTextBoxSelector.slice(1)}`) as HTMLInputElement | null;
			this.searchButton = document.getElementById(`${this.controlServerData.searchButtonId.slice(1)}`);

			if (this.searchButton) {
				this.searchButton.addEventListener('click', this.navigateToResults.bind(this));
			}
			if (this.searchTextBox) {
				this.searchTextBox.addEventListener('keypress', this.keypressHandler.bind(this));

				/* Initialization */
				if (this.controlServerData.disableSuggestions === "false") {
					this.searchTextBox.addEventListener('keyup', this.keyupHandler.bind(this));
				}
			}

		}
		// Append the search suggestions
		suggestionsSuccessHandler(result) {
			if (!this.autocomplete) return;

			this.autocompleteResults = result.Suggestions;

			const searchAutocomplete = `
            <ul class="search-autocomplete__list">
            ${result.Suggestions.map((item) => {
				const url = this.getLocation(item);
				return `<li class="search-autocomplete__item">
                        <a href="${url}" class="search-autocomplete__link">${item}</a>
                    </li>`
			}).join('')}
                </ul>
            `;
			this.autocomplete.innerHTML = "";
			this.autocomplete.insertAdjacentHTML('beforeend', searchAutocomplete);
			this.autocompleteActive = true;
		}
		// When clicking on an suggestion result
		// add the value to the search input field
		selectAutocompleteResult(e) {
			if (!this.searchTextBox) return;

			const target = e.target;
			const text = target.textContent;
			this.searchTextBox.value = text || '';
		}
		keyupHandler(e) {
			if (!this.searchTextBox) return;

			if (e.keyCode != 38 &&  // up arrow
				e.keyCode != 40 && // down arrow
				e.keyCode != 27) { // esc
				// When the auto complete menu is shown, only this event is detected
				if (e.keyCode == 13) {
					// when enter is pressed
					this.navigateToResults(e);
				}

				const searchText = this.searchTextBox.value.trim();
				this.searchValue = searchText;
				if (searchText.length >= this.controlServerData.minSuggestionLength) {
					const api = `${this.controlServerData.suggestionsRoute}?IndexName=${this.controlServerData.indexCatalogue}&SuggestionFields=${this.controlServerData.suggestionFields}&Text=${searchText}&Language=${this.controlServerData.language}`;
					fetch(api)
						.then((response) => response.json())
						.then((data) => {
							this.suggestionsSuccessHandler(data);
						});
				} else if (searchText.length === 0) {
					this.clearAutoComplete();
				}
			}
			if (this.autocompleteActive) {
				this.autocompleteEvents(e);
			}
		}

		// Get location of search results page
		getLocation(term) {
			const query = term.trim();

			const separator = (this.controlServerData.resultsUrl.indexOf("?") == -1) ? "?" : "&";

			const catalogueParam = separator + "indexCatalogue=" + encodeURIComponent(this.controlServerData.indexCatalogue);
			const searchQueryParam = "&searchQuery=" + encodeURIComponent(query);
			const wordsModeParam = "&wordsMode=" + this.controlServerData.wordsMode;

			let url = this.controlServerData.resultsUrl + catalogueParam + searchQueryParam + wordsModeParam;

			if (this.controlServerData.scoringSettings) {
				url = url + "&scoringInfo=" + this.controlServerData.scoringSettings;
			}

			return url;
		}

		sendSentence() {
			if (!this.searchTextBox) return;

			if ((window as any).DataIntelligenceSubmitScript) {
				(window as any).DataIntelligenceSubmitScript._client.sentenceClient.writeSentence({
					predicate: "Search for",
					object: this.searchTextBox.value,
					objectMetadata: [{
						'K': 'PageUrl',
						'V': location.href
					}]
				});
			}
		}

		/* Event handlers */
		keypressHandler(e) {
			const code = e.keyCode;
			// Enter
			if (code == 13) {
				this.navigateToResults(e);
			}
		}
		// Clears autocomplete suggestions and sets search input value to initial query
		clearAutoComplete() {
			this.autocompleteIndex = -1;
			if (this.autocomplete) {
				this.autocomplete.innerHTML = "";
			}
			this.autocompleteActive = false;
			this.autocompleteResults = [];
			if (this.searchTextBox) {
				this.searchTextBox.value = this.searchValue;
			}
		}
		// Move up and down through the suggestions
		// Hit Escape to close suggestions
		autocompleteEvents(e) {
			if (!this.searchTextBox) return;

			// Up
			const code = e.keyCode;
			if (code === 38) {
				this.autocompleteIndex--;
				if (this.autocompleteIndex < 0) {
					this.autocompleteIndex = this.autocompleteResults.length - 1;
				}
				this.searchTextBox.value = this.autocompleteResults[this.autocompleteIndex];
			}
			// Down
			if (code === 40) {
				this.autocompleteIndex++;
				if (this.autocompleteIndex > this.autocompleteResults.length - 1) {
					this.autocompleteIndex = 0;
				}
				this.searchTextBox.value = this.autocompleteResults[this.autocompleteIndex];
			}
			// ESC
			if (code === 27) {
				this.clearAutoComplete();
			}
		}
		// Navigate to search results page with query
		navigateToResults(e) {
			e.preventDefault();

			if (!this.searchTextBox) return;

			const query = this.searchTextBox.value;

			if (query && query.trim() && this.controlServerData.indexCatalogue) {
				this.sendSentence();
				window.location.href = this.getLocation(query);
			}
		}
	}


	const searchBoxIdFields = document.querySelectorAll('[data-sf-role="searchTextBoxId"]');
	searchBoxIdFields.forEach((field) => {
		const searchBox = new SearchBox(field);
	});
}